__turbopack_context__.v({
  "announcmentBlock": "MobileAnnouncments-module-scss-module__0MLD3a__announcmentBlock",
  "announcmentDescription": "MobileAnnouncments-module-scss-module__0MLD3a__announcmentDescription",
  "announcmentTitle": "MobileAnnouncments-module-scss-module__0MLD3a__announcmentTitle",
  "root": "MobileAnnouncments-module-scss-module__0MLD3a__root",
});
